import { toast } from "react-toastify";
import axiosInstance from "../config/axios-config";
import axiosInstanceV2 from "../config/axios-v2-config";
const BASE_BRAND_DRUG_URL = "/v1/brand-drug";
const BASE_V2_BRAND_DRUG_URL = "/v2/brand-drug";

// Search brand drug names by prefix
export const searchBrandDrugNames = async (startsWith: string | null) => {
  try {
    const response = await axiosInstanceV2.get(
      `${BASE_V2_BRAND_DRUG_URL}/search`,
      {
        params: { startsWith: startsWith },
      }
    );
    if (response.status !== 200) {
      throw Error("Unable to search brand drug names");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable to search brand drug names");
  }
};

export const getBrandDrugNameByGenericName = async (genericNameId: string) => {
  try {
    const response = await axiosInstanceV2.get(
      `${BASE_V2_BRAND_DRUG_URL}/generic/${genericNameId}`
      // {
      //   params: { genericNameId: genericNameId },
      // }
    );

    if (response.status !== 200) {
      throw Error("Unable retrieve brand name data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable retrieve brand name data");
  }
};

export const addNewBrandDrugName = async ({
  brandDrugName,
  contents,
  formulation,
  genericNameId,
}: {
  brandDrugName: string;
  contents: string;
  formulation: string;
  genericNameId: string;
}) => {
  try {
    console.log("baseurl=", axiosInstanceV2.defaults.baseURL);
    const response = await axiosInstanceV2.post(BASE_V2_BRAND_DRUG_URL, {
      name: brandDrugName,
      contents: contents,
      formulation_type: formulation,
      generic_name_id: genericNameId,
    });
    if (response.status !== 201) {
      throw Error("Unable save brand name data");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    throw Error("Unable save brand name data");
  }
};

export const updateBrandDrug = async ({
  id,
  name,
  contents,
  formulationType,
}: {
  id: string;
  name: string;
  contents: string;
  formulationType: string;
}) => {
  try {
    const response = await axiosInstanceV2.patch(
      `${BASE_V2_BRAND_DRUG_URL}/${id}`,
      {
        name: name,
        contents: contents,
        formulation_type: formulationType,
      }
    );
    if (response.status !== 200) {
      toast.error("Unable to update brand drug");
      throw Error("Unable to update brand drug");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to update brand drug");
    throw Error("Unable to update brand drug");
  }
};

export const deleteBrandDrug = async (id: string) => {
  try {
    const response = await axiosInstanceV2.delete(
      `${BASE_V2_BRAND_DRUG_URL}/${id}`
    );
    if (response.status !== 200 && response.status !== 204) {
      toast.error("Unable to delete brand drug");
      throw Error("Unable to delete brand drug");
    } else {
      return response.data;
    }
  } catch (error) {
    console.log(error);
    toast.error("Unable to delete brand drug");
    throw Error("Unable to delete brand drug");
  }
};
